module.exports = __webpack_public_path__ + "static/media/qinotify_logo.aa1c09b1.png";